import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import classNames from 'classnames';
import css from './CommentCount.module.scss';

/** A media's comment count behind a bubble. Nothing at zero, or when the count is unknown. */
export const CommentCount = ({ count, className }: { count?: number; className?: string }) => {
  if (!count) return null;
  const label = `${count} ${count === 1 ? 'comment' : 'comments'}`;
  return (
    <span className={classNames(css.commentCount, className)} title={label} aria-label={label}>
      <ChatBubbleOutlineRoundedIcon className={css.icon} aria-hidden />
      {count}
    </span>
  );
};
